import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Page from '_components/Page';
import {
  vehicleService,
  vehicleTypeService,
} from '_services';

function Add({ history, match }) {
  const [isLoading, setIsLoading] = useState(false);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [error, setError] = useState(null);
  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    getVehicleTypes();
  }, []);

  const getVehicleTypes = () => {
    vehicleTypeService
      .getSuggestion()
      .then((x) => {
        setVehicleTypes(x.content);
      })
      .catch((errorInfo) => {
        message.error(`${errorInfo}`);
      });
  };

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);
        vehicleService
          .create(values)
          .then(() => {
            setIsLoading(false);
            history.push('.');
          })
          .catch((error) => {
            setIsLoading(false);
            setError(error);
          });
      })
      .catch((errorInfo) => {});
  };

  const onCancel = () => {
    history.push('.');
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to='/dashboard'>Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to='/vehicles'>Vehicle Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to='/vehicles/add'>New Vehicle</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={[
          <Button
            key='1'
            htmlType='submit'
            loading={isLoading}
            onClick={handleFormSumbit}
          >
            Save
          </Button>,
          <Button key='2' htmlType='button' onClick={onCancel}>
            Cancel
          </Button>,
        ]}
      >
        <Page inner error={error}>
          <Form
            form={form}
            name='form-create'
            layout='vertical'
            requiredMark={false}
          >
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  name='number'
                  label='Vehicle Number'
                  rules={[
                    { required: true, message: 'Vehicle Number is required' },
                  ]}
                >
                  <Input placeholder='Number' allowClear />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name={['type', 'id']}
                  label='Vehicle Type'
                  rules={[
                    {
                      required: true,
                      message: 'Vehicle Type is required',
                    },
                  ]}
                >
                  <Select placeholder='Please select' allowClear>
                    {vehicleTypes.map((t) => (
                      <Option value={t.id} key={t.id}>
                        {t.type}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}></Col>
              <Col span={6}></Col>
            </Row>
          </Form>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Add;
